import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableTextLeftNarrow: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "left",
    margin: "10px",
    padding: "6px",
    minWidth: "140px",
    maxWidth: "220px",
    whiteSpace: "normal",
    wordBreak: "break-word",
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function MediaTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };

  const extractDomainFromUrl = (url) => {
    if (!url) return "-";

    try {
      const protocolIndex = url.indexOf('//');
      if (protocolIndex === -1) return "-";

      const domainStart = protocolIndex + 2;
      const pathIndex = url.indexOf('/', domainStart);

      if (pathIndex === -1) {
        return url.substring(domainStart);
      } else {
        return url.substring(domainStart, pathIndex);
      }
    } catch (error) {
      return "-";
    }
  };

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>Data de publicação</TableCell>
            <TableCell className={classes.tableHeader}>Título da notícia</TableCell>
            <TableCell className={classes.tableHeader}>Fonte</TableCell>
            <TableCell className={classes.tableHeader}>Envolvimento</TableCell>
            <TableCell className={classes.tableHeader}>Operação</TableCell>
            <TableCell className={classes.tableHeader}>Link</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.news.map((exposure, index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            >
              <TableCell className={classes.tableText}>
                {exposure.date == null ? "-" : moment(exposure.date).format('DD/MM/YYYY')}
              </TableCell>
              <TableCell className={classes.tableText}>
                {exposure.title ? `"${exposure.title}"` : "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {exposure.source || extractDomainFromUrl(exposure.url)}
              </TableCell>
              <TableCell className={classes.tableTextLeftNarrow}>
                {exposure.involvement || "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {exposure.operation || "-"}
              </TableCell>
              <TableCell className={classes.tableText}>
                {exposure.url ?
                <a
                  href={exposure.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Link
                </a> : "-"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default MediaTable;
